import { render } from "./OrgManagementDashboard.vue?vue&type=template&id=0ae4d366"
import script from "./OrgManagementDashboard.vue?vue&type=script&lang=js"
export * from "./OrgManagementDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__